<template>
  <j-modal
    :title="title"
    :width="500"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleOk">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.dictName')">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.dictName')])"
            v-decorator="['dictName', validatorRules.dictName]"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.dictCode')">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.dictCode')])"
            v-decorator="['dictCode', validatorRules.dictCode]"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.note')">
          <a-textarea
            @keyup.enter.stop
            v-decorator="['description']"
            :maxLength="255"
            :autoSize="{ minRows: 4 }"
            :placeholder="$t('disp.ph.input', [$t('disp.note')])"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addDict, editDict, duplicateCheck } from '@/api/api'

export default {
  name: 'DictModal',
  data() {
    return {
      value: 1,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      loading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        dictName: { rules: [{ required: true, message: this.$t('disp.rules.require') }] },
        dictCode: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }, { validator: this.validateDictCode }],
        },
      },
    }
  },
  created() {},
  methods: {
    validateDictCode(rule, value, callback) {
      if (value && value.length > 0) {
        if (new RegExp(/^[\x00-\xff]+$/).test(value)) {
          // 重複チェック
          var params = {
            tableName: 'sys_dict',
            fieldName: 'dict_code',
            fieldVal: value,
            dataId: this.model.id,
          }
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.$t('disp.rules.duplicate', [this.$t('disp.dictCode')]))
            }
          })
        } else {
          callback(this.$t('disp.rules.half'))
        }
      } else {
        callback()
      }
    },
    handleChange(value) {
      this.model.status = value
    },
    add() {
      this.edit({})
    },
    edit(record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'dictName', 'dictCode', 'description'))
      })
    },
    // 確定
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          values.dictName = (values.dictName || '').trim()
          values.dictCode = (values.dictCode || '').trim()
          values.description = (values.description || '').trim()
          let formData = Object.assign(this.model, values)
          let obj
          console.log(formData)
          if (!this.model.id) {
            obj = addDict(formData)
          } else {
            obj = editDict(formData)
          }
          obj
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.$emit('ok')
              }
            })
            .finally(() => {
              that.loading = false
              that.close()
            })
        } else {
          that.loading = false
        }
      })
    },
    // 閉じる
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>
